import { SVGProps } from "react"

const ChairIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 1.875H10.625C11.6196 1.875 12.5734 2.27009 13.2767 2.97335C13.9799 3.67661 14.375 4.63044 14.375 5.625V9.375H5.625V5.625C5.625 4.63044 6.02009 3.67661 6.72335 2.97335C7.42661 2.27009 8.38044 1.875 9.375 1.875V1.875Z"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 15.625C6.25 15.2935 6.3817 14.9755 6.61612 14.7411C6.85054 14.5067 7.16848 14.375 7.5 14.375H12.5C12.8315 14.375 13.1495 14.5067 13.3839 14.7411C13.6183 14.9755 13.75 15.2935 13.75 15.625"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.875V14.375"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4562 9.375H5.54375C4.89827 9.375 4.375 9.89827 4.375 10.5438V10.7062C4.375 11.3517 4.89827 11.875 5.54375 11.875H14.4562C15.1017 11.875 15.625 11.3517 15.625 10.7062V10.5438C15.625 9.89827 15.1017 9.375 14.4562 9.375Z"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 16.25C6.875 15.9048 6.59518 15.625 6.25 15.625C5.90482 15.625 5.625 15.9048 5.625 16.25V17.5C5.625 17.8452 5.90482 18.125 6.25 18.125C6.59518 18.125 6.875 17.8452 6.875 17.5V16.25Z"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.375 16.25C14.375 15.9048 14.0952 15.625 13.75 15.625C13.4048 15.625 13.125 15.9048 13.125 16.25V17.5C13.125 17.8452 13.4048 18.125 13.75 18.125C14.0952 18.125 14.375 17.8452 14.375 17.5V16.25Z"
        stroke={props.color || "#687079"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChairIcon
